import { configureStore } from "@reduxjs/toolkit";
import projectReducer from "./slice/ProjectSlice";
import UIReducer from "./slice/UISlice";
import ProjectImageSlice from "./slice/ProjectImageSlice";
import projectTrainReducer from "./slice/ProjectTrainSlice";
import ProjectTestReducer from "./slice/ProjectTestSlice";
import ProjectImagesUploadedReducer from "./slice/ProjectImagesUploadedSlice";
import ProjectTasksReducer from "./slice/ProjectTasksSlice";
import ProjectLabelReducer from "./slice/ProjectLabelSlice";
import ProjectAnnotationReducer from "./slice/projectAnnotationSlice";
import UserSliceReducer from "./slice/authSlice";
import WorkFlowReducer from "./slice/WorkFlowSlice";

export const store = configureStore({
  reducer: {
    project: projectReducer,
    UIReducer: UIReducer,
    projectImage: ProjectImageSlice,
    projectTrain: projectTrainReducer,
    projectTest: ProjectTestReducer,
    ProjectImagesUploaded: ProjectImagesUploadedReducer,
    Tasks: ProjectTasksReducer,
    projectLabel: ProjectLabelReducer,
    projectAnnotation: ProjectAnnotationReducer,
    auth: UserSliceReducer,
    workflow: WorkFlowReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
